var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-form-wrapper',{attrs:{"server-errors":_vm._se,"v":_vm.$v.item,"schema":_vm.schema,"form-state":_vm.formState},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})}
var staticRenderFns = []

export { render, staticRenderFns }